export default "__VITE_ASSET__BKz5VupY__"